import { trustpilotColor } from "@/components/trustpilot/ultis/trustpilotColorHelpers";

const STAR_COUNT = 5;
const EMPTY_STAR_COLOR = "#dcdce6";

const STAR_PATH =
  "M12,17.964l5.214-1.321l2.179,6.714L12,17.964z M24,9.286h-9.179L12,0.643L9.179,9.286 H0l7.429,5.357l-2.821,8.643l7.429-5.357l4.571-3.286L24,9.286L24,9.286L24,9.286L24,9.286z";

interface TrustpilotStarProps {
  size?: number;
}

interface TrustpilotStarsProps {
  rating?: number;
  size?: number;
}

const TrustpilotStar = ({ size = 12 }: TrustpilotStarProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path d={STAR_PATH} fill="#ffffff" />
  </svg>
);

const calculateFillPercent = (rating: number, starIndex: number): number => {
  const starNumber = starIndex + 1;

  if (rating >= starNumber) {
    return 100;
  }

  if (rating > starIndex) {
    return (rating - starIndex) * 100;
  }

  return 0;
};

const TrustpilotStars = ({ rating = 5, size = 24 }: TrustpilotStarsProps) => {
  const validRating = Math.max(0, Math.min(STAR_COUNT, rating));
  const color = trustpilotColor(validRating);

  return (
    <div
      style={{
        display: "flex",
        gap: 2,
        alignItems: "center",
      }}
    >
      {Array.from({ length: STAR_COUNT }).map((_, index) => (
        <div
          key={index}
          style={{
            width: size,
            height: size,
            position: "relative",
            background: EMPTY_STAR_COLOR,
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              width: `${calculateFillPercent(validRating, index)}%`,
              background: color,
            }}
          />

          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TrustpilotStar size={size * 0.55} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustpilotStars;
